import React from 'react';
import { color, font, space, weight } from '../theme';
import Button from './Button';
import Icon, { IconName } from './Icon';

interface EmptyStateProps {
  title: string;
  body?: React.ReactNode;
  icon?: IconName;
  // e.g. a "clear filters" Button
  action?: React.ReactNode;
}

// Nothing to show: no results for a filter, or no data of this kind
export const EmptyState = ({ title, body, icon = 'search', action }: EmptyStateProps) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: space.sm, padding: `${space.xxxl}px ${space.lg}px` }}>
    <span style={{ width: 48, height: 48, borderRadius: '50%', background: color.surfaceMuted, color: color.textTertiary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Icon name={icon} size={22} />
    </span>
    <div style={{ fontSize: font.body, fontWeight: weight.medium, color: color.text }}>{title}</div>
    {body && <div style={{ fontSize: font.small, color: color.textSecondary, maxWidth: 300, lineHeight: 1.5 }}>{body}</div>}
    {action && <div style={{ marginTop: space.xs }}>{action}</div>}
  </div>
);

interface ErrorStateProps {
  onRetry: () => void;
  message?: string;
}

// A read failed. Replaces the endless "טוען..." a failed read leaves today.
export const ErrorState = ({ onRetry, message = 'לא הצלחנו לטעון את הנתונים. ייתכן שיש בעיית חיבור.' }: ErrorStateProps) => (
  <div role="alert" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: space.sm, padding: `${space.xxxl}px ${space.lg}px` }}>
    <span style={{ width: 48, height: 48, borderRadius: '50%', background: '#FCEBEB', color: '#501313', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Icon name="alert" size={22} />
    </span>
    <div style={{ fontSize: font.body, fontWeight: weight.medium, color: color.text }}>משהו השתבש</div>
    <div style={{ fontSize: font.small, color: color.textSecondary, maxWidth: 300, lineHeight: 1.5 }}>{message}</div>
    <Button icon="refresh" onClick={onRetry} style={{ marginTop: space.xs }}>נסו שוב</Button>
  </div>
);
